export interface MaterializedTablePropertyColumnInput {
  uuidColumn: string;
  propertyNames: string[];
}

export interface MaterializedTableFormulaInput {
  formula: string;
  parameters: string[];
  statistics: string[];
}

export interface MaterializedTableFilterInput {
  valueFilter: {
    filterType: string;
    columnName: string;
    value: string;
  };
}

export const GET_MATERIALIZED_TABLE_QUERY =
  'query GetTable($id: String!, $filter: FilterInput, $limit: Int!, $columnsToInclude: [String!], ' +
  '$propertiesToInclude: [PropertiesForItemUUIDColumnInput!], $includeOverrides: Boolean!, ' +
  '$tableFormulas: [TableFormulaInput!], $sorts: [SortInput!], $cursor: CursorInput) { table(id: $id, filter:' +
  ' $filter, limit: $limit, columnsToInclude: $columnsToInclude, propertiesToInclude: $propertiesToInclude, ' +
  'includeOverrides: $includeOverrides, tableFormulas: $tableFormulas, sorts: $sorts, cursor: $cursor)' +
  '{ rows headers { name type } hasMore cursorKey } }';
